<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <!-- 车牌号码 -->
      <section slot="car" slot-scope="prop">
        <ChooseCar
          :isRadio="true"
          v-model="prop.form.car"
          @change="handleChange"
        />
      </section>
      <section slot="claimAccident" slot-scope="prop">
        <ChooseClaimAccident
          :isRadio="true"
          v-model="prop.form.claimAccident"
          :otherSearchData="{
            vehicleCode: prop.form.car.vehicleCode
          }"
        />
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getDepartmentAllList,
} from 'api';
import {
  mapState,
} from 'vuex';
import ChooseCar from 'components/choose/car';
import ChooseClaimAccident from 'components/choose/claimAccident';
export default {
  components: {
    ChooseCar,
    ChooseClaimAccident,
  },
  data () {
    return {
      baseForm: {
        orgIdOptions: [],
        form: [
          {
            label: '车牌号',
            value: 'car',
            slot: true,
            default: {},
          },
          {
            label: '选择事故',
            value: 'claimAccident',
            slot: true,
            default: {},
            hide: true,
          },
          {
            label: '收到理赔金额',
            value: 'reciClaimAmount',
            type: 'input',
          },
          {
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            disabled: true,
          },
        ],
        rules: {
          car: [ // 车牌号
            { required: true, message: '请选择车牌号', trigger: 'blur' },
          ],
          reciClaimAmount: [ // 收到理赔金额
            { required: true, message: '请输入收到理赔金额', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    handleChange () {
      const car = this.$refs.baseForm.getVal('car');
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: !car.plateNumber,
        names: ['claimAccident'],
      });
    },
    async getList () {
      this.baseForm.orgIdOptions = await getDepartmentAllList();
    },
    async sub () {
      const formData = await this.$refs.baseForm.sub();
      if (formData) {
        formData.plateNumber = formData.car.plateNumber;
        delete formData.car;
        formData.accidentTime = formData.claimAccident.accidentTime;
        formData.accidentAddress = formData.claimAccident.accidentAddress;
        formData.ourLossAmount = formData.claimAccident.ourLossAmount;
        formData.otherLossAmout = formData.claimAccident.otherLossAmout;
        delete formData.claimAccident;
        formData.reciClaimAmount = formData.reciClaimAmount * 100;
      }
      return formData;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      return res;
    },
    async init (data = {}) {
      data.car = data.car || {};
      data.claimAccident = data.claimAccident || {};
      data.orgId = Number(this.userInfo.staffTFInfo.orgIds.split(',')[0]);
      this.$refs.baseForm.setVal(data);
      this.handleChange();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
